import React from 'react';
import {Button} from '../Button';
import {Drawer} from '../Drawer';
import {ExclamationMark} from '../ExclamationMark';
import {ErrorBanner} from './ErrorBanner';
import cn from 'classnames';

export type ErrorBannerWithDrawerProps = {
	text?: string | null;
	description?: string | null;
	okButtonText?: string;
	className?: string;
};

export function ErrorBannerWithDrawer({
	text,
	okButtonText = 'Окей',
	className,
}: ErrorBannerWithDrawerProps): React.ReactElement {
	const [open, setOpen] = React.useState(false);

	return (
		<>
			<button type="button" onClick={() => setOpen(true)} className="w-full text-left focus:outline-none">
				<ErrorBanner text={text} className={cn('cursor-pointer p-2 focus-visible:ring-2 mb-7', className)} />
			</button>

			<Drawer
				open={open}
				onClose={() => setOpen(false)}
				titleIcon={<ExclamationMark rounded />}
				title="Что-то не так"
				footerContent={
					<Button className="!w-full !px-6 !py-4 !text-base" onClick={() => setOpen(false)}>
						{okButtonText}
					</Button>
				}
			>
				{text && <p className="max-w-[360px] text-sm leading-relaxed text-black/70">{text}</p>}
			</Drawer>
		</>
	);
}
